"use strict";
/** Copied over from OPF's implementation
 * https://stash.int.klarna.net/projects/APF/repos/acquiring-purchase-flow-client/browse/src/utils/devices/parseUserAgent.ts?until=9a23c5bb355fb2bbcdbb8ee8a59c09774cbea256&untilPath=src%2Futils%2Fdevices%2FparseUserAgent.ts
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAndroidWebView = exports.isIosWebView = exports.isWebView = exports.isFirefox = exports.isSamsungBrowser = exports.isChrome = exports.isMobileSafari = exports.isDesktopOs = exports.isAndroid = exports.isIos = exports.isMobile = exports.UBUNTU = exports.LINUX = exports.CHROMIUM_OS = exports.WINDOWS = exports.MAC_OS = exports.DUCKDUCKGO = exports.BRAVE = exports.SAMSUNG_BROWSER = exports.SAFARI = exports.MOBILE_SAFARI = exports.CHROME = exports.EDGE = exports.FIREFOX = exports.IOS_WEBVIEW = exports.ANDROID_WEBVIEW = exports.ANDROID = exports.IOS = void 0;
exports.parseUserAgent = parseUserAgent;
const ua_parser_js_1 = require("ua-parser-js");
exports.IOS = 'ios';
exports.ANDROID = 'android';
exports.ANDROID_WEBVIEW = 'chrome webview';
exports.IOS_WEBVIEW = 'webkit';
exports.FIREFOX = 'firefox';
exports.EDGE = 'edge';
exports.CHROME = 'chrome';
exports.MOBILE_SAFARI = 'mobile safari';
exports.SAFARI = 'safari';
exports.SAMSUNG_BROWSER = 'samsung browser';
exports.BRAVE = 'brave';
exports.DUCKDUCKGO = 'duckduckgo';
exports.MAC_OS = 'mac os';
exports.WINDOWS = 'windows';
exports.CHROMIUM_OS = 'chromium os';
exports.LINUX = 'linux';
exports.UBUNTU = 'ubuntu';
const WELL_KNOWN_WEBVIEWS = new Set([
    'tiktok',
    'instagram',
    'linkedin',
    'facebook',
    /* Google Search App */
    'gsa',
]);
function parseUserAgent() {
    try {
        const { userAgent } = window.navigator;
        const parser = new ua_parser_js_1.UAParser(userAgent);
        return {
            browser: {
                name: parser.getBrowser().name?.toLowerCase(),
            },
            os: {
                name: parser.getOS().name?.toLowerCase(),
            },
        };
    }
    catch {
        return undefined;
    }
}
const isMobile = () => {
    const { userAgent } = window.navigator;
    const parser = new ua_parser_js_1.UAParser(userAgent);
    return parser.getResult().device.type === 'mobile';
};
exports.isMobile = isMobile;
// OS
const isIos = (parsedUserAgent = parseUserAgent()) => parsedUserAgent?.os.name === exports.IOS;
exports.isIos = isIos;
const isAndroid = (parsedUserAgent = parseUserAgent()) => parsedUserAgent?.os.name === exports.ANDROID;
exports.isAndroid = isAndroid;
const isDesktopOs = (parsedUserAgent = parseUserAgent()) => {
    const os = parsedUserAgent?.os.name;
    if (typeof os !== 'string') {
        return false;
    }
    const desktopOsRegex = new RegExp(`${exports.CHROMIUM_OS}|${exports.LINUX}|${exports.MAC_OS}|${exports.UBUNTU}|${exports.WINDOWS}`, 'iu');
    return desktopOsRegex.test(os);
};
exports.isDesktopOs = isDesktopOs;
// Browser
const isMobileSafari = (parsedUserAgent = parseUserAgent()) => parsedUserAgent?.browser.name === exports.MOBILE_SAFARI;
exports.isMobileSafari = isMobileSafari;
const isChrome = (parsedUserAgent = parseUserAgent()) => parsedUserAgent?.browser.name === exports.CHROME;
exports.isChrome = isChrome;
const isSamsungBrowser = (parsedUserAgent = parseUserAgent()) => parsedUserAgent?.browser.name === exports.SAMSUNG_BROWSER;
exports.isSamsungBrowser = isSamsungBrowser;
const isFirefox = (parsedUserAgent = parseUserAgent()) => parsedUserAgent?.browser.name === exports.FIREFOX;
exports.isFirefox = isFirefox;
// WebView
/**
 * `isWebView` is a function that doesn't necessarily detect actual webviews
 * but rather browsers and webviews where we _THINK_ we can *NOT* support
 * opening URLs in new tabs.
 */
const isWebView = (parsedUserAgent = parseUserAgent()) => {
    const browserName = parsedUserAgent?.browser.name;
    if (typeof browserName !== 'string') {
        return false;
    }
    if (WELL_KNOWN_WEBVIEWS.has(browserName)) {
        return true;
    }
    // In some cases, WKWebView integrations are detected as Safari/Mobile Safari,
    // in which case the browser check is not enough to determine if it's a webview.
    // Because of that, we also check if the `window.webkit.messageHandlers` object
    // exists to determine if it's a webview. Additionally, we only do this check
    // when the browser name is "Safari" or "Mobile Safari" to avoid false positives
    // in other iOS browsers.
    if ((0, exports.isIos)() &&
        [exports.SAFARI, exports.MOBILE_SAFARI].includes(browserName) &&
        window.webkit?.messageHandlers !== undefined) {
        return true;
    }
    return ![
        // The other browsers has not been tested and have very small share of OPF
        // sessions therefore we treat them as webviews. In the future if any of the
        // browsers gain significant share of OPF sessions we should test them and
        // add them to the list.
        exports.SAFARI,
        exports.MOBILE_SAFARI,
        exports.CHROME,
        exports.FIREFOX,
        exports.EDGE,
        exports.SAMSUNG_BROWSER,
        exports.BRAVE,
        exports.DUCKDUCKGO,
    ].includes(browserName);
};
exports.isWebView = isWebView;
const isIosWebView = (parsedUserAgent = parseUserAgent()) => (0, exports.isIos)(parsedUserAgent) && (0, exports.isWebView)(parsedUserAgent);
exports.isIosWebView = isIosWebView;
const isAndroidWebView = (parsedUserAgent = parseUserAgent()) => (0, exports.isAndroid)(parsedUserAgent) && (0, exports.isWebView)(parsedUserAgent);
exports.isAndroidWebView = isAndroidWebView;
